<template>
  <section
    v-if="Object.keys(props.data).length > 0 && props.data?.crossSellProducts?.list?.length"
    class="relatedProducts"
    :class="[ props.data.parentClasses, props.data.parentStyle ? props.data.parentStyle : 'defaultStyle' ]"
  >
    <div class="container col">
      <div class="relatedProducts__header section-heading">
        <strong class="label primary-color-text text-base-1 text-primary">
          {{ $t('relatedProducts') }}
        </strong>

        <div
          v-if="(props.data.parentStyle === 'defaultStyle' || props.data.parentStyle === 'secondStyle') && props.data.crossSellProducts.list.length > 1"
          class="flex slider-nav relatedProducts__navigation"
        >
          <button
            class="relatedProducts__navigation__prev swiper-arrow prev"
            :aria-label="$t('preview')"
            type="button"
          >
            <span class="icon icon-left-arrow"></span>
          </button>
          <button
            class="relatedProducts__navigation__next swiper-arrow next"
            :aria-label="$t('next')"
            type="button"
          >
            <span class="icon icon-right-arrow"></span>
          </button>
        </div>
      </div>

      <div class="relatedProducts__body">
        <div
          v-if="props.data.parentStyle === 'secondStyle_2' && props.data.crossSellProducts.list.length > 1"
          class="slider-nav relatedProducts__navigation"
        >
          <button
            class="relatedProducts__navigation__prev swiper-arrow prev"
            :aria-label="$t('preview')"
            type="button"
          >
            <span class="icon icon-left-arrow"></span>
          </button>
          <button
            class="relatedProducts__navigation__next swiper-arrow next"
            :aria-label="$t('next')"
            type="button"
          >
            <span class="icon icon-right-arrow"></span>
          </button>
        </div>

        <Swiper
          :modules="[Pagination, Navigation]"
          :slides-per-view="3"
          :loop="false"
          :space-between="16"
          :navigation="{
            prevEl: '.relatedProducts__navigation__prev',
            nextEl: '.relatedProducts__navigation__next'
          }"
          :pagination="{
            clickable: true
          }"
          :breakpoints="props.data.slider && props.data.slider.breakpoints ? props.data.slider.breakpoints : {
            0: {
              slidesPerView: 1,
            },
            480: {
              slidesPerView: 1,
            },
            650: {
              slidesPerView: 2
            },
            993: {
              slidesPerView: 4
            }
          }"
        >
          <SwiperSlide
            v-for="product in props.data.crossSellProducts.list"
            :key="product"
          >
            <div class="card center-align">
              <NuxtLink
                role="button"
                :to="`/product/${product.urlpathname}-${product.id}`"
                :title="product.productTitle"
                class=""
              >
                <div class="card-image">
                  <NuxtPicture
                    preload
                    loading="lazy"
                    :img-attrs="{class: 'responsive-img', alt: product.imageAlt}"
                    :src="product.imageOriginal ? product.imageOriginal : '/img/na.png'"
                    height="270"
                    width="450"
                  />
                </div>
                <div class="card-content">
                  <span class="label">{{ product.subtypeTitle }}</span>
                  <h4 class="clear-link">
                    {{ product.productTitle }}
                  </h4>
                  <span
                    v-if="props.data.showMoreBtn"
                    class="text-link"
                  >{{ $t('viewProduct') }}</span>
                </div>
              </NuxtLink>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  </section>
</template>

<script setup>
import { Pagination, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'

/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  }
})
</script>

<style lang="scss" scoped>
.relatedProducts {
  position: relative;
  &__header {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }
  &__body {
    .swiper {
      padding-bottom: 1rem;
    }
  }

  /*
  * Second Style
  */
  &.secondStyle {
    .relatedProducts {
      &__header {
        justify-content: center;
        margin-bottom: 3rem;
        .label {
          margin-bottom: 0;
          font-weight: 300!important;
        }
      }
    }
  }

  /*
  /*
  * Second Style
  */
  &.secondStyle_2 {
    .relatedProducts {
      &__header {
        justify-content: center;
        margin-bottom: 3rem;
      }
      &__body {
        padding: 0 2rem;
      }
    }
  }
}

.card {
  padding: 0;
  margin: 0;
  box-shadow: none;
  transition: color .3s ease-in-out 0s, border .3s ease-in-out 0s, background .3s ease-in-out 0s, opacity .3s ease-in-out 0s, box-shadow .3s ease-in-out 0s, -webkit-box-shadow .3s ease-in-out 0s;
  &-content {
    padding: 1.375rem 1.125rem;
  }
  &-image {
    height: 0;
    padding-bottom: 60%;
    &:deep(img) {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;

      object-fit: cover;
    }
  }
  &:hover {
    .clear-link {
      color: color("primary-color", "base");
    }
    .text-link {
      color: color("primary-color", "base");
      border-bottom-color: color("primary-color", "base");
    }
  }
}
</style>
